WiseMetering.Views.FillIndicatorGaps = WiseMetering.Views.Modal.Custom.extend({
    template: 'templates/indicators/fill_gaps',
    form_prefix: 'fill_gaps',
    width: 500,
    title: () => i18next.t('modal.title.indicators.fill_gaps'),
    buttons: ['apply', 'cancel'],

    serializeData: function() {
        return {
            unit: this.model.get('unit')
        };
    },

    onRender: function() {
        this.$('select#fill_gaps_strategy').on('change', () => this.updateStrategy());
        this.updateStrategy();
        this.loadGaps();
    },

    loadGaps: function() {
        const that = this;

        this.modal.block();
        this.model.previewGaps().then(
            function(gaps) {
                that.modal.unblock();

                if (!gaps.length) {
                    that.$('#fill_gaps_list').html(`<b>${i18next.t('indicators.fill_gaps.none')}</b>`);
                    that.modal.$('#apply').prop('disabled', true);
                    return;
                }

                const timezone = that.model.timezone();
                const items = gaps.map(function(gap) {
                    const from = moment.tz(gap.start * 1000, timezone).format('YYYY-MM-DD HH:mm');
                    const to = moment.tz((gap.finish + 1) * 1000, timezone).format('YYYY-MM-DD HH:mm');
                    const days = Math.round(gap.slots / 96);
                    return `<li>${from} &rarr; ${to} (${days} ${i18next.t('common.days')})</li>`;
                });
                that.$('#fill_gaps_list').html(`<b>${i18next.t('indicators.fill_gaps.detected')}:</b><ul>${items.join('')}</ul>`);
            },
            function() {
                that.modal.unblock();
                that.$('.err').html(i18next.t('ui.unspecified_error'));
                that.modal.$('#apply').prop('disabled', true);
            }
        );
    },

    updateStrategy: function() {
        const strategy = this.$('select#fill_gaps_strategy').val();

        this.$('#fill_gaps_value_field').toggle(strategy === 'constant');
        this.$('#fill-gaps-strategy-title').text(this.$('select#fill_gaps_strategy option:selected').text());
        this.$('#fill-gaps-strategy-description').text(i18next.t(`indicators.fill_gaps.${strategy}_description`));
    },

    apply: function() {
        const
            that = this,
            $errors = this.$('.err'),
            strategy = this.$('select#fill_gaps_strategy').val(),
            payload = { strategy };

        if (strategy === 'constant') {
            const value = this.$('input#fill_gaps_value').val();
            if (!value) {
                $errors.html(i18next.t('indicators.fill_gaps.specify_value'));
                return;
            }
            payload.value = parseFloat(value);
        }

        const bucketsBefore = this.model.buckets().length;
        this.block();

        this.model.fillGaps(payload).then(
            function(indicator) {
                that.model.set(indicator);
                // Refetch the buckets so the new estimates and the snapped neighbour
                // windows show up without a page reload
                WiseMetering.buckets.fetch().always(function() {
                    const filled = that.model.buckets().length - bucketsBefore;
                    if (filled > 0) {
                        WiseMetering.layout.showTipper('success', i18next.t('indicators.fill_gaps.filled', { count: filled }));
                    } else {
                        WiseMetering.layout.showTipper('info', i18next.t('indicators.fill_gaps.none'));
                    }
                    that.close();
                });
            },
            function(xhr) {
                let error = i18next.t('ui.unspecified_error');
                try {
                    error = JSON.parse(xhr.responseText).error;
                } catch (e) {
                }
                $errors.html(error);
                that.unblock();
            }
        );
    }
});
